module.exports = __webpack_public_path__ + "static/sanpy-73b0120ae0a89bd6dc8cc014ff2fa937.png";